export const CAR_NUMBER = 1;
export const MOTORCYCLE_NUMBER = 2;
export const BUS_NUMBER = 3;
export const CARGO_VEHICLE_NUMBER = 4;
export const NAUTICAL_VEHICLE_NUMBER = 5;
export const AGRICULTURAL_VEHICLE_NUMBER = 6;
export const SERVICES_NUMBER = 7;
export const PARTS_NUMBER = 8;
export const STORES_NUMBER = 9;
